import React from 'react';
import HowitWorksPage from './HowitWorksPage/HowitWorksPage';

const HowitWorks = () => {
    return (
        <div>
            <HowitWorksPage />
        </div>
    );
};

export default HowitWorks;
